export const Metric = 'Metric'
export const Imperial = 'Imperial'
export const JpUnitsOfArea = 'JpUnitsOfArea'
export const ThUnitsOfArea = 'ThUnitsOfArea'

export const KilloMeterPerHour = 'km/h'
export const MilePerHour = 'mph'
export const MeterPerSecond = 'm/s'

export const Celsius = '℃'
export const Fahrenheit = '℉'
export const Percent = '%'
export const MilliMetres = 'mm'
